<ng-container *ngIf="!gameRankingPuckList">
    <div class="px-6 py-8">
        <span class="text-base bg-white border-1 border-slate-300 py-2 px-5 rounded-full">Loading</span>
    </div>
</ng-container>
<ng-container *ngIf="gameRankingPuckList">
    <div class="px-6 py-2">
        <h3 class="text-lg font-semibold text-gray-700">Ranking</h3>
    </div>

    <div cdkDropList [cdkDropListData]="gameRankingPuckList" (cdkDropListDropped)="onDrop($event)"
        class="mt-2 px-6 pr-14">
        <div *ngFor="let gameRankingSlot of gameRankingPuckList; let i = index" 
            cdkDrag [cdkDragDisabled]="!gameRankingSlot" (cdkDragStarted)="onDrag(i)"
            class="flex h-22 w-full items-center">
            <ng-container *ngIf="gameRankingSlot; else placeholder">
                <div class="flex flex-row w-full h-20 border-2 bg-white border-slate-400 rounded-2xl cursor-pointer">
                    <div class="flex h-full w-15 items-center justify-center">
                        <span class="text-3xl text-slate-400 font-medium">
                            {{ i + 1 }}
                        </span>
                    </div>
                    <div class="flex flex-col h-full grow justify-center">
                        <div>
                            <span class="text-lg font-medium">
                                {{ gameRankingSlot.performerName }} - {{ gameRankingSlot.songName }}
                            </span>
                        </div>
                        <div>
                            <span>{{ gameRankingSlot.countryName }}</span>
                        </div>
                    </div>
                    <div class="flex h-full w-15 items-center justify-center">
                        <button aria-label="Performance rating" class="">
                            <ng-container *ngIf="!gameRankingSlot.rating">
                                favorite_border
                            </ng-container>
                            <ng-container *ngIf="gameRankingSlot.rating">
                                favorite
                            </ng-container>
                        </button>
                    
                        <div class="w-18">
                            <div class="flex flex-col justify-center px-3 py-1">
                                <button (click)="ratePerformance(gameRankingSlot.performanceId, 'love')" aria-label="Love the performance" class="">
                                    love
                                </button>
                                <button (click)="ratePerformance(gameRankingSlot.performanceId, 'like')" aria-label="Like the performance" class="">
                                    like
                                </button>
                                <button (click)="ratePerformance(gameRankingSlot.performanceId, 'loathe')" aria-label="Loathe the performance" class="">
                                    loathe
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #placeholder>
                <div class="flex flex-row w-full h-17 border-2 bg-white border-slate-200 rounded-3xl">
                    <div class="flex h-full w-15 items-center justify-center">
                        <span class="text-3xl text-slate-200 font-medium">
                            {{ i + 1 }}
                        </span>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>

</ng-container>
